( (app, ng) => {

    var editReportResolves = {
        reportType: ["$transition$", function ($transition$) {
            return $transition$.params().type;
        }],
        fields: ["reportType", "reportFields", function (reportType, reportFields) {
            return ng.copy(reportFields[reportType]);
        }],
        //customFields: ['customFieldApi', 'reportType', function (customFieldApi, reportType) {
        //    if (reportType === 'Client') return customFieldApi.getClientCustomFields();
        //    if (reportType === 'Account') return customFieldApi.getAccountCustomFields();
        //    if (reportType === 'ClientReferral') return customFieldApi.getClientCustomFields();
        //}],
        taskStatuses: [function () { return ["Open", "Complete"]; }],
        riskTolerances: ["riskTolerances", function (riskTolerances) {
            return riskTolerances;
        }],
        prefixes: ["prefixes", function (prefixes) {
            return prefixes;
        }],
        investmentKnowledges: ["investmentKnowledges", function (investmentKnowledges) {
            return investmentKnowledges;
        }],
        investmentObjectives: ["_investmentObjectives", function (investmentObjectives) {
            return investmentObjectives;
        }],
        accountStatuses: ["caseTimelineStatusTypes", function (caseTimelineStatusTypes) {
            return caseTimelineStatusTypes;
        }],
        states: ["_states", function (states) {
            return states;
        }],
        genders: ["genders", function (genders) {
            return genders;
        }],
        householdRelationshipTypes: ["_householdRelationshipTypes", function (householdRelationshipTypes) {
            return householdRelationshipTypes;
        }],
        taxFilingStatuses: ["taxFilingStatuses", function (taxFilingStatuses) {
            return taxFilingStatuses;
        }],
        employmentStatuses: ["employmentStatuses", function (employmentStatuses) {
            return employmentStatuses;
        }],
        lineOfBusinesses: ["lineOfBusinesses", function (lineOfBusinesses) {
            return lineOfBusinesses;
        }]
    };

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Reports.New",
                {
                    url: "/{type}/New",
                    component: "editReport",
                    resolve: ng.extend(ng.copy(editReportResolves),
                        {
                            report: [
                                function () {
                                    var unsavedReport = sessionStorage.getItem("__unsavedReport");

                                    return unsavedReport ? JSON.parse(sessionStorage.getItem("__report")) : null;
                                }
                            ]
                        }),
                    onExit: ["$transition$", function (trans) {
                        if (trans.to().name !== "Home.Reports.Results") {
                            sessionStorage.removeItem("__report");
                            sessionStorage.removeItem("__unsavedReport");
                        }
                    }],
                    redirectTo: "Home.Reports.New.FieldGridView"
                });
        }
    ]);

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Reports.Edit",
                {
                    url: "/{type}/Edit/{reportId}",
                    component: "editReport",
                    resolve: ng.extend(ng.copy(editReportResolves),
                        {
                            report: [
                                "$transition$", "reportApi", function ($transition$, reportApi) {
                                    var unsavedReport = sessionStorage.getItem("__unsavedReport");

                                    return unsavedReport
                                        ? JSON.parse(sessionStorage.getItem("__report"))
                                        : reportApi.get($transition$.params().reportId);
                                }
                            ]
                        }),
                    onEnter: ["$state", "currentUser", "report", function ($state, currentUser, report) {
                        if (report.OwnerId !== currentUser.Id)
                            return $state.target("Home.401");

                        return true;
                    }],
                    onExit: ["$transition$", function (trans) {
                        if (trans.to().name !== "Home.Reports.Results") {
                            sessionStorage.removeItem("__report");
                            sessionStorage.removeItem("__unsavedReport");
                        }
                    }],
                    redirectTo: "Home.Reports.Edit.FieldGridView"
                });
        }
    ]);

    app.component("editReport",
        {
            templateUrl: "/App/Reports/EditReport/editreport-template.html",
            controller: editReportController,
            bindings: {
                report: "<",
                reportType: "<",
                fields: "<",
                //customFields: "<",
                currentUser: "<",
                taskStatuses: "<",
                riskTolerances: "<",
                investmentKnowledges: "<",
                investmentObjectives: "<",
                accountStatuses: "<",
                states: "<",
                genders: "<",
                householdRelationshipTypes: "<",
                taxFilingStatuses: "<",
                employmentStatuses: "<",
                lineOfBusinesses: "<",
                prefixes: "<"
            }
        });

    editReportController.$inject = ["customFieldApi", "_", "$q", "$scope", "$state", "$transitions", "$mdDialog", "$timeout", "reportApi", "tagApi", "advisorApi", "subUserApi", "carrierApi", "carrierProductApi", "taxQualificationApi", "investmentAccountTypeApi", "custodianApi", "clientApi", "_formPattern"];
    function editReportController(customFieldApi, _, $q, $scope, $state, $transitions, $mdDialog, $timeout, reportApi, tagApi, advisorApi, subUserApi, carrierApi, carrierProductApi, taxQualificationApi, investmentAccountTypeApi, custodianApi, clientApi, formPattern) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                ui: {
                    unsaved: false,
                    filters: [
                        { name: "all of the selected options", value: "all", type: "array" },
                        { name: "at least one of the selected options", value: "any", type: "array" },
                        { name: "is exactly", value: "=", type: "string" },
                        { name: "contains", value: "substring", type: "string" },
                        { name: "starts with", value: "startsWith", type: "string" },
                        { name: "ends with", value: "endsWith", type: "string" },
                        { name: "is greater than", value: ">", type: "comparison" },
                        { name: "is greater than or equal to", value: ">=", type: "comparison" },
                        { name: "is equal to", value: "=", type: "comparison" },
                        { name: "is less than or equal to", value: "<=", type: "comparison" },
                        { name: "is less than", value: "<", type: "comparison" },
                        { name: "is between", value: "and", type: "comparison" },
                        { name: "is after", value: ">", type: "date" },
                        { name: "is after (month)", value: ">month", type: "date", useMonth: true },
                        { name: "is after or equal to", value: ">=", type: "date" },
                        { name: "is after or equal to (month)", value: ">=month", type: "date" },
                        { name: "is equal to", value: "=", type: "date" },
                        { name: "is equal to (month)", value: "=month", type: "date" },
                        { name: "is before or equal to", value: "<=", type: "date" },
                        { name: "is before or equal to (month)", value: "<=month", type: "date" },
                        { name: "is before", value: "<", type: "date" },
                        { name: "is before (month)", value: "<month", type: "date" },
                        { name: "is between", value: "and", type: "date" },
                        { name: "is between (month)", value: "andmonth", type: "date" }
                    ],
                    customFilters: [
                        { name: "all of the selected options", value: "All", type: "array" },
                        { name: "at least one of the selected options", value: "Any", type: "array" },
                        { name: "is exactly", value: "Equals", type: "string" },
                        { name: "contains", value: "Substring", type: "string" },
                        { name: "starts with", value: "StartsWith", type: "string" },
                        { name: "ends with", value: "EndsWith", type: "string" },
                        { name: "is after", value: "AfterDate", type: "date" },
                        { name: "is after (month)", value: "AfterMonth", type: "date", useMonth: true },
                        { name: "is after or equal to", value: "AfterOrEqualToDate", type: "date" },
                        { name: "is after or equal to (month)", value: "AfterOrEqualToMonth", type: "date" },
                        { name: "is equal to", value: "EqualToDate", type: "date" },
                        { name: "is equal to (month)", value: "EqualToMonth", type: "date" },
                        { name: "is before or equal to", value: "BeforeOrEqualToDate", type: "date" },
                        { name: "is before or equal to (month)", value: "BeforeOrEqualToMonth", type: "date" },
                        { name: "is before", value: "BeforeDate", type: "date" },
                        { name: "is before (month)", value: "BeforeMonth", type: "date" },
                        { name: "is between", value: "BetweenDates", type: "date" },
                        { name: "is between (month)", value: "BetweenMonths", type: "date" }
                    ]
                },
                months: [
                    "January", "February", "March", "April", "May", "June", "July", "August", "September", "October",
                    "November", "December"
                ],
                activeFields: [],
                activeCustomFields: [], //TODO: merge when filter custom fields is available
                condition: {
                    operation: "and",
                    parameters: []
                },
                customConditions: [
                    //{
                    //    Type: "String / Array / DateTime",
                    //    Operation: "Substring, StartsWith, Equals, EndsWith, Any,AfterDate,AfterMonth,AfterOrEqualToDate,AfterOrEqualToMonth,EqualToDate,EqualToMonth,BeforeOrEqualToDate,BeforeOrEqualToMonth,BeforeDate,BeforeMonth,BetweenDates,BetweenMonths
                    //    Parameter: "[customfieldId]",
                    //    Constant: "[selections, or entry]",
                    //    DateTimeConstant: "[datePicker]"
                    //}
                ],
                customFields: [],
                searchText: "",
                addTag: addTag,
                exportReport: exportReport,
                formPattern: formPattern,
                isCustomFieldSelected: isCustomFieldSelected,
                isSelected: isSelected,
                itemMoved: itemMoved,
                moveColumn: moveColumn,
                runReport: runReport,
                saveReport: saveReport,
                searchTags: searchTags,
                //selectAll: selectAll,
                //selectAllCustomFields: selectAllCustomFields,
                //toggleField: toggleField,
                updateCustomFilter: updateCustomFilter,
                updateFilter: updateFilter
            });

        var deregisterFn = $transitions.onStart({
            to: "**",
            exiting: function (state) {
                return state.name === "Home.Reports.Edit" || state.name === "Home.Reports.New";
            }
        },
            function (trans) {
                if (trans.to().name !== "Home.Reports.Results" && $ctrl.ui.unsaved) {
                    var confirm = $mdDialog.confirm({
                        theme: "confirmDelete",
                        title: "Unsaved Changes",
                        textContent: "Are you sure you want to leave? All unsaved changes to the report will be lost.",
                        ariaLabel: "Unsaved report changes",
                        ok: "Leave",
                        cancel: "Cancel",
                        onComplete: function focusCancel() {
                            var $dialog = ng.element(document.querySelector("md-dialog"));
                            var $actionsSection = $dialog.find("md-dialog-actions");
                            var $cancelButton = $actionsSection.children()[0];
                            $cancelButton.focus();
                        }
                    });

                    return $mdDialog.show(confirm).then(function () {

                    },
                        function () {
                            trans.abort();
                        });
                }
            });

        this.$onDestroy = deregisterFn;

        function updateCustomFilter(field, filterType) {
            var condition = _.find($ctrl.customConditions,
                function (condition) {
                    return condition.Parameter === field.Id;
                });
            if (!condition) {
                condition = {
                    Type: filterType,
                    Operation: field.Operation,
                    Parameter: field.Id,
                    Constant: getConstant(field, filterType)
                };
                $ctrl.customConditions.push(condition);
                return;
            }

            condition.Operation = field.Operation;
            condition.Parameter = field.Id;
            condition.Type = filterType;
            condition.Constant = getConstant(field, filterType);
            $ctrl.ui.unsaved = true;
        }

        function getConstant(field, filterType) {
            if (!field.Constant) {
                return [];
            }

            if (filterType === "String") {
                return [field.Constant];
            }

            if (filterType === "Array") {
                return field.Constant;
            }

            if (filterType === "DateTime") {
                if (field.Operation.includes("Between")) {
                    var constantOne = field.Constant[0] ? field.Constant[0] : null;
                    var constantTwo = field.Constant[1] ? field.Constant[1] : null;
                    return [constantOne, constantTwo];
                }
                else {
                    return [field.Constant[0] ? field.Constant[0] : field.Constant];
                }
            }
        }

        function updateFilter(field) {
            var parameter = _.find($ctrl.condition.parameters,
                function (param) {
                    return (param.parameters[0].parameter === field.Name || param.parameters[0].parameter === field.ConditionName) ||
                        (param.parameters[0].parameters && param.parameters[0].parameters[1].parameter === field.Name);
                });

            if (!parameter) {
                parameter = {
                    type: field.Type
                };

                $ctrl.condition.parameters.push(parameter);
            }

            parameter.operation = !field.FilterType ? "contains" : field.operation;

            if (!!field.operation && field.operation.includes("and")) {
                parameter.parameters = [
                    {
                        operation: !field.operation.includes("month") ? ">=" : ">=month",
                        type: field.Type,
                        parameters: [
                            { parameter: field.Name },
                            { constant: field.left }
                        ]
                    },
                    {
                        operation: !field.operation.includes("month") ? "<=" : "<=month",
                        type: field.Type,
                        parameters: [
                            { parameter: field.Name },
                            { constant: field.right }
                        ]
                    }
                ];
            } else {
                parameter.parameters = [
                    { parameter: field.ConditionName || field.Name },
                    { constant: field.constant || "" }
                ];
                parameter.type = field.Type;
            }

            $ctrl.ui.unsaved = true;
        }

        function cleanReport() {
            if (!$ctrl.report) $ctrl.report = {};
            //Remove empty filters from conditions
            _.remove($ctrl.condition.parameters,
                function (param) {
                    return param.parameters[1].constant === ""
                        || Array.isArray(param.parameters[1].constant) && param.parameters[1].constant.length === 0
                        || param.parameters[0].parameters && (param.parameters[0].parameters[1].constant === "" || param.parameters[0].parameters[1].constant === "")
                        || param.operation === null;
                });
            //Remove empty custom filters form conditions list
            _.remove($ctrl.customConditions,
                function (condition) {
                    return condition.Constant === ""
                        || condition.Constant.length === 0
                        || condition.Type === "Array" && condition.Constant.length === 0
                        || condition.Parameter === null
                        || condition.Operation === null;
                });
            if (!$ctrl.report.Id) {
                ng.extend($ctrl.report,
                    {
                        Type: $ctrl.reportType,
                        OwnerId: $ctrl.currentUser.Id,
                        Owner: $ctrl.currentUser,
                        Properties: {
                            Parameters: _.map($ctrl.activeFields, "Name"),
                            Condition: $ctrl.condition,
                            Type: $ctrl.reportType
                        },
                        CustomProperties: $ctrl.activeCustomFields.length
                            ? {
                                Parameters: _.map($ctrl.activeCustomFields, "Id"),
                                Conditions: $ctrl.customConditions
                            }
                            : null,
                        IsPublic: false
                    });
            } else {
                $ctrl.report.Properties.Parameters = _.map($ctrl.activeFields, "Name");
                $ctrl.report.Properties.Condition = $ctrl.condition;
                //TODO: merge when filter custom fields is available
                $ctrl.report.CustomProperties = $ctrl.activeCustomFields.length
                    ? {
                        Parameters: _.map($ctrl.activeCustomFields, "Id"),
                        Conditions: $ctrl.customConditions
                    }
                    : null;
            }

            sessionStorage.setItem("__report", JSON.stringify($ctrl.report));
        }

        function saveReport() {
            $ctrl.ui.saving = true;
            cleanReport();

            var promises = [];
            if (!$ctrl.report.Id) {
                promises.push(reportApi["create" + $ctrl.reportType + "Report"]($ctrl.report));
            } else {
                promises.push(reportApi["update" + $ctrl.reportType + "Report"]($ctrl.report.Id, $ctrl.report));
            }

            $q.all(promises)
                .then((response) => {
                    if (!$ctrl.report.Id) {
                        $state.go("Home.Reports.Edit", { type: response[0].Type, reportId: response[0].Id });
                    }

                    $ctrl.ui.unsaved = false;
                    $ctrl.ui.saved = true;
                    $ctrl.ui.saving = false;
                    $timeout(function () {
                        $ctrl.ui.saved = false;
                    },
                        5000);
                })
                .catch((error) => {
                    console.log("Error", error);
                });
        }

        function runReport() {
            cleanReport();

            sessionStorage.setItem("__unsavedReport", !$ctrl.report.Id || $ctrl.ui.unsaved);
            $state.go("Home.Reports.Results", { reload: true });
        }

        function getReportFile(exportedReportId) {
            return reportApi.getExportedReport(exportedReportId).then(function (response) {
                if (response === null)
                    return getReportFile(exportedReportId);
                else return response;
            });
        }

        function exportReport() {
            $ctrl.ui.exporting = true;
            cleanReport();

            reportApi.export($ctrl.report).then(function (response) {
                getReportFile(response.Id).then(function (file) {
                    var f = document.createElement("a");
                    document.body.appendChild(f);
                    f.style = "display:none";

                    var fUrl = window.URL.createObjectURL(file);
                    f.href = fUrl;
                    f.download = $ctrl.report.Name ? $ctrl.report.Name + ".xls" : "untitled.xls";
                    f.click();
                    $ctrl.ui.exporting = false;

                    $timeout(function () {
                        document.body.removeChild(f);
                        window.URL.revokeObjectURL(fUrl);
                    },
                        100);
                });
            });
        }

        function addTag(field, newTag, existingTag) {
            var containsTag = _.find(field.constant,
                function (row) {
                    return row.toUpperCase() === newTag.toUpperCase() || (!!existingTag && existingTag.Value.toUpperCase() === row.toUpperCase());
                });

            if ((newTag !== "" || existingTag !== null) && !containsTag) {
                var tag = !existingTag ? newTag : existingTag.Value;
                if (!field.constant)
                    field.constant = [tag];
                else field.constant.push(tag);

                //bind search text model to each field
                field.searchText = "";
                $ctrl.searchText = "";
                $ctrl.selectedItem = "";
                $ctrl.updateFilter(field);
            }
        }

        function searchTags(term) {
            return tagApi.search(term);
        }

        function itemMoved(index) {
            console.log(index);
        }

        function moveColumn(array, from, to) {
            if (to >= 0 || to >= array.length - 1) {
                var column = array.splice(from, 1)[0];
                array.splice(to, 0, column);
            }
        }

        function getFilters() {
            if ($ctrl.reportType === "Client" || $ctrl.reportType === "Account" || $ctrl.reportType === "ClientReferral")
                advisorApi.getCurrentUserParentAdvisors().then(function (response) {
                    $ctrl.advisors = response;
                    $ctrl.advisors.push({
                        Id: $ctrl.currentUser.AdvisorId,
                        Person: {
                            FirstName: $ctrl.currentUser.FirstName,
                            LastName: $ctrl.currentUser.LastName
                        }
                    });
                });

            if ($ctrl.reportType === "Appointment" || $ctrl.reportType === "ScheduledTask")
                subUserApi.getParents().then(function (response) {
                    $ctrl.users = _.map(response, function (subUser) { return subUser.User; });
                    $ctrl.users.push($ctrl.currentUser);
                });

            if ($ctrl.reportType === "Account") {
                carrierApi.getCarriers().then(function (response) {
                    $ctrl.carriers = response;
                });

                carrierProductApi.getCarrierProductsList().then(function (response) {
                    $ctrl.products = response;
                });

                taxQualificationApi.getTaxQualifications().then(function (response) {
                    $ctrl.taxQualifications = response;
                });

                investmentAccountTypeApi.getInvestmentAccountTypes().then(function (response) {
                    $ctrl.investmentAccountTypes = response;
                });

                custodianApi.getCustodians().then(function (response) {
                    $ctrl.custodians = response;
                });
            }

            if ($ctrl.reportType === "Client" || $ctrl.reportType === "ClientReferral") {
                clientApi.getClientTypes().then(function (response) {
                    $ctrl.clientTypes = response;
                });
            }
        }

        function isSelected(field) {
            if (!!field.constant && !Array.isArray(field.constant)) return true;
            if (Array.isArray(field.constant) && field.constant.length > 0) return true;
            if (!!field.left && !!field.right) return true;
            return false;
        }

        function isCustomFieldSelected(customField) {
            if (!!customField.Constant && !Array.isArray(customField.Constant)) return true;
            if (Array.isArray(customField.Constant) && customField.Constant.length > 0) return true;
            return false;
        }

        function getCustomFields(reportType) {
            if (reportType === 'Client') return customFieldApi.getClientCustomFields();
            if (reportType === 'Account') return customFieldApi.getAccountCustomFields();
            if (reportType === 'ClientReferral') return customFieldApi.getClientCustomFields();
            else return $q.when(null);
        }

        $ctrl.$onInit = () => {
            getFilters();
            getCustomFields($ctrl.reportType).then(response => {
                response
                    .filter(field => field.IsActive)
                    .forEach(field => $ctrl.customFields.push({
                        Id: field.Id,
                        Name: field.FieldName,
                        DisplayName: field.FieldName,
                        Type: field.CustomFieldType,
                        TextOptionsList: field.TextOptionsList
                    }));

                if ($ctrl.report && $ctrl.report.CustomProperties) {
                    ng.forEach($ctrl.report.CustomProperties.Parameters,
                        function (paramId) {
                            var customField = _.find($ctrl.customFields,
                                function (customField) {
                                    return customField.Id === paramId;
                                });

                            if (customField) {
                                customField.Active = true;

                                var customCondition = _.find($ctrl.customConditions,
                                    function (condition) {
                                        return condition.Parameter === customField.Id;
                                    });
                                if (customCondition) {
                                    customField.Operation = customCondition.Operation;
                                    if (customField.Type === "DateTime" && customField.Operation.includes("Month")) {
                                        customField.Constant = _.map(customCondition.Constant, (constant) => {
                                            return parseInt(constant);
                                        });
                                    } else {
                                        customField.Constant = !!customCondition.Constant
                                            ? customCondition.Constant
                                            : [];
                                        //customField.DateTimeConstant = !!customCondition.DateTimeConstant ? customCondition.DateTimeConstant : [];
                                    }
                                }

                                $ctrl.activeCustomFields.push(customField);
                            }
                        });
                }
                //$ctrl.ui.selectAllCustomFields = $ctrl.activeCustomFields.length === $ctrl.customFields.length;
            });
            if ($ctrl.report) {
                $ctrl.condition = $ctrl.report.Properties.Condition;
                $ctrl.customConditions = !!$ctrl.report.CustomProperties && $ctrl.report.CustomProperties.Conditions
                    ? $ctrl.report.CustomProperties.Conditions
                    : [];
                //TODO: Remove when report modul updated to include custom properties
                ng.forEach($ctrl.report.Properties.Parameters,
                    function (param) {
                        var field = _.find($ctrl.fields,
                            function (field) {
                                return field.Name === param;
                            });

                        if (field) {
                            field.Active = true;

                            var condition = _.find($ctrl.condition.parameters,
                                function (param) {
                                    return param.parameters[0].parameter === field.Name || param.parameters[0].parameter === field.ConditionName ||
                                        param.parameters[0].parameters && param.parameters[0].parameters[1].parameter === field.Name;
                                });

                            if (condition) {
                                field.operation = condition.operation;

                                if (condition.operation.includes("and")) {
                                    field.left = condition.parameters[0].parameters[1].constant;
                                    field.right = condition.parameters[1].parameters[1].constant;

                                } else {
                                    field.constant = condition.parameters[1].constant;
                                }
                            }

                            $ctrl.activeFields.push(field);
                        }
                    });
                $ctrl.ui.unsaved = !$ctrl.report.Id;
                //$ctrl.ui.selectAll = $ctrl.activeFields.length === $ctrl.fields.length;
            }
        }
    }

})(window.app, window.angular);